import React, { useCallback, useEffect } from 'react';
import { Table } from 'antd';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { RIDE_STATUSES } from '../../../constants/constants';
import { useWindowSize } from '../../../hooks/useWindowSIze';

import styles from './index.module.css';

export const BaseTable = ({ 
  columns, 
  onRowClick, 
  data, 
  isTCWorker, 
  components, 
  addHoverEffectToRowTable,
  // Optional tree table properties with safe defaults
  expandable = null
}) => {
  const [, innerHeight] = useWindowSize();
  const handleRowClassName = (record) => {
    // Build class list based on conditions
    const classNameList = [];
   
    // Status-based styling
    if (isTCWorker && record?.status === RIDE_STATUSES.PENDING) {
      classNameList.push(styles.newRequestRow);
    } else if (record?.status === RIDE_STATUSES.CLAIMED) {
      classNameList.push(styles.claimedRow);
    } else if (record?.status === RIDE_STATUSES.UNABLE_TO_FULFILL) {
      classNameList.push(styles.unableToFullfillRow);
    }
    
    // Add parent row styling if the row has children
    if (record.children && record.children.length > 0) {
      classNameList.push(styles.parentRow);
    }
     // Add child row styling
    if (record.parentOrgId ) {
      classNameList.push(styles.parentRow);
    }
    
    return classNameList.join(' ');
  };

  const onRow = useCallback((record) => (onRowClick ? { onClick: onRowClick(record) } : null), [onRowClick]);

  useEffect(() => {
    const tableBody = document.querySelector('.ant-table-body');

    if (data && tableBody) {
      tableBody.scrollTop = 0;
    }
    return;
  }, [data]);
  
  // Determine if data has tree structure
  const hasTreeData = data?.some(item => item.children && item.children.length > 0);
  
  // Only apply tree-specific classes if data has children
  const tableClassName = classNames({
    [styles.baseTable]: true,
    [styles.hoverOnRow]: addHoverEffectToRowTable,
    [styles.treeTable]: hasTreeData,
  });

  return (
    <Table
      className={tableClassName}
      pagination={false}
      columns={columns}
      dataSource={data}
      rowClassName={handleRowClassName}
      onRow={onRow}
      components={components}
      scroll={data?.length > 0 ? { x: 'max-content', y: innerHeight - 300 } : { x: 'max-content' }}
      // If expandable is provided, use it, otherwise auto-detect tree data
      {...(expandable !== null ? { expandable } : hasTreeData ? { childrenColumnName: 'children' } : {})}
    />
  );
};

BaseTable.propTypes = {
  columns: PropTypes.oneOfType([PropTypes.array, PropTypes.bool]),
  renderTableHead: PropTypes.func,
  onRowClick: PropTypes.func,
  data: PropTypes.array,
  dataLoaded: PropTypes.bool,
  isTCWorker: PropTypes.bool,
  components: PropTypes.object,
  addHoverEffectToRowTable: PropTypes.bool,
  // New prop types for tree table
  expandable: PropTypes.object,
};
